import { ActivityGroupType } from "../enums";

export class ActivityGroup {
  id: number;
  name: string;
  type: ActivityGroupType;
  typeData: any;
}
